<fgb-banner [bannerTitle]="'nav.faq' | translate"></fgb-banner>

<fgb-page-header [pageTitle]="'nav.faq'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
